import { render, staticRenderFns } from "./DataDisplay.vue?vue&type=template&id=1b846f07"
import script from "./DataDisplay.vue?vue&type=script&lang=js"
export * from "./DataDisplay.vue?vue&type=script&lang=js"
import style0 from "./DataDisplay.vue?vue&type=style&index=0&id=1b846f07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports